var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        viewBox: '0 0 16 17',
        version: '1.1'
    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
        id: 'Projects',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none'
    }, React.createElement('g', {
        id: 'URL-Edit',
        transform: 'translate(-836.000000, -314.000000)'
    }, React.createElement('g', {
        id: 'Edit-icon',
        transform: 'translate(832.000000, 312.000000)'
    }, React.createElement('path', {
        d: 'M18,18 L5,18',
        id: 'Path-301',
        stroke: '#323232',
        strokeWidth: '2'
    }), React.createElement('path', {
        d: 'M6,16 L7,12 L15,4 L18,7 L10,15 L6,16 Z',
        id: 'Path-302',
        stroke: '#323232',
        strokeWidth: '2'
    }), React.createElement('path', {
        id: 'Path-303',
        stroke: '#979797',
        d: ''
    })))));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/EditorEdit.svg
// module id = 522
// module chunks = 1